import { OnOffSwitch } from "@/components/OnOffSwitch";

const VIEWS = [["summary", "Summary only"], ["detail", "Full Detail"], ["annual", "Annual Summary"], ["conference", "Conference Summary"], ["financial", "Financial Summary"], ["receipts", "My receipts (view, print, download)"]];
const ENTRIES = [["tithes", "Tithe"], ["progress", "Progress Reports"], ["registrations", "Conference Registration"], ["donations", "Conference Collection"]];

function Grid({ title, help, rows, prefix, perms, onSet, testid }) {
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-5" data-testid={testid}>
      <h3 className="font-heading text-lg font-bold">{title}</h3>
      <p className="text-sm text-slate-500">{help}</p>
      <div className="mt-3 grid grid-cols-[1fr_5.5rem_5.5rem] gap-3 text-center text-xs font-bold uppercase tracking-wider text-slate-500"><span /><span>General Council</span><span>MWJK</span></div>
      {rows.map(([k, label]) => (
        <div key={k} className="grid grid-cols-[1fr_5.5rem_5.5rem] items-center gap-3 border-b border-slate-100 py-3 last:border-0">
          <span className="font-semibold text-slate-900">{label}</span>
          {["gc", "mwjk"].map((s) => {
            const key = `${prefix}_${k}_${s}`;
            return <span key={s} className="flex justify-center"><OnOffSwitch checked={!!perms[key]} onChange={(v) => onSet(key, v)} testid={`perm-${key}`} /></span>;
          })}
        </div>
      ))}
    </section>
  );
}

export function AdminChurchAccess({ settings, save }) {
  const perms = settings.permissions || {};
  const onSet = (k, v) => save({ permissions: { ...perms, [k]: v } });
  const feats = settings.features || {};
  return (
    <>
      <section className="rounded-xl border border-slate-200 bg-white p-5" data-testid="receipts-switch-card">
        <h3 className="font-heading text-lg font-bold">Receipts</h3>
        <p className="text-sm text-slate-500">ON = the Receipt Book works on that side. Which admins can use it is set in each admin's "Receipts" switch in Users & Logins.</p>
        <div className="mt-3 flex flex-wrap gap-6">
          {[["gc", "General Council"], ["mwjk", "MWJK"]].map(([s, l]) => (
            <label key={s} className="flex items-center gap-3 font-semibold text-slate-900">{l}<OnOffSwitch checked={feats[`receipts_${s}`] !== false} onChange={(v) => save({ features: { ...feats, [`receipts_${s}`]: v } })} testid={`feature-receipts_${s}`} /></label>
          ))}
        </div>
      </section>
      <section className="rounded-xl border border-slate-200 bg-white p-5" data-testid="other-switch-card">
        <h3 className="font-heading text-lg font-bold">Other Collection</h3>
        <p className="text-sm text-slate-500">ON = Other Collection works on that side. Which admins can use it is set in each admin's "Other Collection" switch in Users & Logins.</p>
        <div className="mt-3 flex flex-wrap gap-6">
          {[["gc", "General Council"], ["mwjk", "MWJK"]].map(([s, l]) => (
            <label key={s} className="flex items-center gap-3 font-semibold text-slate-900">{l}<OnOffSwitch checked={feats[`other_${s}`] !== false} onChange={(v) => save({ features: { ...feats, [`other_${s}`]: v } })} testid={`feature-other_${s}`} /></label>
          ))}
        </div>
      </section>
      <Grid title="Local church — report views" help="ON = local churches can open this report view. They only ever see their own church's numbers." rows={VIEWS} prefix="church_view" perms={perms} onSet={onSet} testid="church-view-perms-card" />
      <Grid title="Local church — entry (4 places)" help={'Churches can enter only these four, and only for their own church. Turn ON to let churches enter and edit on that side. When OFF, they see "Entry is closed right now."'} rows={ENTRIES} prefix="church_entry" perms={perms} onSet={onSet} testid="church-entry-perms-card" />
    </>
  );
}
